import {useParams} from "react-router-dom";
import {Tabs} from "antd";
import {PageHeader, ProjectQuota, ProjectToolNav} from "~/components";
import {useCan} from "~/hooks";
import ContentItemsTab from "../components/ContentItemsTab";
import ContentPlansTab from "../components/ContentPlansTab";
import ContentSettingsTab from "../components/ContentSettingsTab";
import ContentTargetsTab from "../components/ContentTargetsTab";

/**
 * Trang tool Nội dung AI của một dự án (`/projects/:id/content`) — §9 AI Automatic Content.
 *
 * Pipeline viết bài chạy NỀN (intent từ SERP thật → dàn ý → viết theo section → ảnh →
 * checklist SEO): tab "Bài viết" theo dõi/duyệt từng bài, tab "Thương hiệu & Cài đặt"
 * là Brand Guideline + chế độ duyệt + nguồn ảnh (user tự cài đặt — quyết §9.7).
 * Dùng chung cap `ai` (nhóm tool AI).
 */
function ContentHome() {

	const {id} = useParams();
	const canAi = useCan('ai');

	if (!canAi) return <div className="container">Bạn không có quyền sử dụng Nội dung AI.</div>;

	return (
		<div className="container">
			<ProjectToolNav projectId={id} active="content" />

			<PageHeader
				icon="fa-light fa-feather-pointed"
				title="Nội dung AI"
				subtitle="AI tự lên dàn ý theo search intent thật, viết bài chuẩn SEO đúng thương hiệu, kèm ảnh minh hoạ"
				actions={<ProjectQuota tool="content" />}
			/>

			<Tabs
				defaultActiveKey="items"
				items={[
					{key: 'items', label: 'Bài viết', children: <ContentItemsTab projectId={id} />},
					{key: 'plans', label: 'Kế hoạch', children: <ContentPlansTab projectId={id} />},
					{key: 'targets', label: 'Kênh đăng', children: <ContentTargetsTab projectId={id} />},
					{key: 'settings', label: 'Thương hiệu & Cài đặt', children: <ContentSettingsTab projectId={id} />},
				]}
			/>
		</div>
	);
}

export default ContentHome;
